import './styles/App.css';
import { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import { Provider } from 'react-redux';
import store from './redux/store';

import ScrollToTop from './utils/global-functions/ScrollToTop';
import GetUserData from './utils/global-functions/GetUserData'; 
import GetPortfolioData from './utils/global-functions/GetPortfolio';
import GetSkills from './utils/global-functions/GetSkills';
import GetLogo from './utils/global-functions/GetLogo';

import Navbar from './components/Navbar';
import Home from "./pages/home/Home";
import Portfolio from "./pages/portfolio/Portfolio";
import ContactMe from "./pages/contact-me/ContactMe";
import ProjectDescription from "./components/project-descripton/ProjectDescription";
import Footer  from './components/Footer';
import LoadingScreen from './components/LoadingScreen';


function App() {
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [portfolioData, setPortfolioData] = useState(null);
  const [skillsData, setSkillsData] = useState(null);
  const [logo, setLogo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchAllData() {
      try {
        setIsLoading(true);
        const [logo, userData, portfolioData, skillsData] = await Promise.all([
          GetLogo(),
          GetUserData(),
          GetPortfolioData(),
          GetSkills()
        ]);
        setLogo(logo);
        setUserData(userData);
        setPortfolioData(portfolioData);
        setSkillsData(skillsData);
        
        if(logo && userData !== null){
          setIsLoading(false);
        }
       
      } catch (error) {
        console.error(error);
        setError(error);
        setIsLoading(true);
      }
  
    }
    fetchAllData();
  }, []);
  
  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 900);
  }, [location]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (error) {
    return <div className="h-screen flex justify-center items-center z-10">An error occurred: {error.message}</div>;
  }

  return (
    <ScrollToTop>
      <Provider store={store}>
        {logo && <Navbar logo={logo} />}
        <Routes>
          {userData && skillsData && <Route path="*" element={<Home userData={userData} skillsData={skillsData} />} />}
          {portfolioData && <Route path="/portfolio/*" element={<Portfolio portfolioData={portfolioData} />} />}
          <Route path="/portfolio/project_description/:projectId/*" element={<ProjectDescription />} />
          {userData && <Route path="/contactMe" element={<ContactMe userData={userData} />} />}
        </Routes>
        {logo && <Footer logo={logo} />}
      </Provider>
    </ScrollToTop>
  );
  
}

export default App;
